export default "__VITE_ASSET__BdFRImmD__"